import { PURCHASE_MANAGER_GROUP_IDS } from "@erp/shared/const/group-capability.const";
import { MEMBER_TYPE } from "./member.types";
/**
 * @description 멤버 모달에 사용되는 기본 멤버 정보(확인, 승인)
 */
export const defaultMemberInfo = [
    {
        type: MEMBER_TYPE.확인,
        givenName: "",
        id: null,
        userName: "",
        email: "",
    },
    {
        type: MEMBER_TYPE.승인,
        givenName: "",
        id: null,
        userName: "",
        email: "",
    },
];
/**
 * @description 멤버 모달에 사용되는 입, 출고 시 멤버 정보(확인, 승인, 자재담당자, 구매담당자)
 */
export const stockMemberInfo = [
    {
        type: MEMBER_TYPE.확인,
        givenName: "",
        id: null,
        userName: "",
        email: "",
    },
    {
        type: MEMBER_TYPE.승인,
        givenName: "",
        id: null,
        userName: "",
        email: "",
    },
    {
        type: MEMBER_TYPE.자재담당자,
        givenName: "",
        id: null,
        userName: "",
        email: "",
    },
    {
        type: MEMBER_TYPE.구매담당자,
        givenName: "",
        id: null,
        userName: "",
        email: "",
        groupIds: [...PURCHASE_MANAGER_GROUP_IDS],
    },
];
